module.exports = __webpack_public_path__ + "img/digitalIdentity20.14589559.png";